import Vue from "vue";
// export async function FetchBagesTypes({ commit }) {
//   commit("cleanErrors");
//   await Vue.axios({
//       method: "GET",
//       url: `/badges/types/`
//     })
//     .then(response => {
//       console.log("response", response)
//     })
//     .catch(error => {
//       commit("error", error);
//     });
// }

// export async function FetchBadgesObjectives({ commit }) {
//   commit("cleanErrors");
//   await Vue.axios({
//       method: "GET",
//       url: `/badges/objectives/`
//     })
//     .then(response => {
//       console.log("response", response)
//     })
//     .catch(error => {
//       commit("error", error);
//     });
// }

export async function FetchParentLockedBadges({ commit }, userId) {
  commit("cleanErrors");
  await Vue.axios({
      method: "GET",
      url: `parent/${userId}/locked_badges/`
    })
    .then(response => {
      commit("setLockedBadges", response.data)
    })
    .catch(error => {
      commit("error", error);
    });
}

export async function FetchParentUnlockedBadges({ commit }, userId) {
    commit("cleanErrors");
    await Vue.axios({
        method: "GET",
        url: `parent/${userId}/unlocked_badges/`
      })
      .then(response => {
        commit("setUnlockedBadges", response.data)
      })
      .catch(error => {
        commit("error", error);
      });
  }

  export async function FetchChildLockedBadges({ commit }, userId) {
    commit("cleanErrors");
    await Vue.axios({
        method: "GET",
        url: `child/${userId}/locked_badges/`
      })
      .then(response => {
        commit("setLockedBadges", response.data)
      })
      .catch(error => {
        commit("error", error);
      });
  }
  
  export async function FetchChildUnlockedBadges({ commit }, userId) {
      commit("cleanErrors");
      await Vue.axios({
          method: "GET",
          url: `child/${userId}/unlocked_badges/`
        })
        .then(response => {
          commit("setUnlockedBadges", response.data)
        })
        .catch(error => {
          commit("error", error);
        });
    }


// export async function FetchChildBadges({ commit }, userId) {
//   commit("cleanErrors");
//   await Vue.axios({
//       method: "GET",
//       url: `child/${userId}/badges_progress/`
//     })
//     .then(response => {
//       commit("setBadges", response.data)
//     })
//     .catch(error => {
//       commit("error", error);
//     });
// }